import { NgModule } from '@angular/core';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { AceCardModule } from '../UI-Lib/ACE/Card/card.module';
import { ChangePasswordComponent } from './Change-Password/changePassword.component';
import { ExternalAPIKeyComponent } from './ExternalAPI/external-api-key.component';
import { NewPasswordComponent } from './New-Password/newPassword.component';
import { AuthenticationService } from './authentication.service';

@NgModule({
    imports: [
        WeissmanSharedModule,
        AceCardModule
    ],
    declarations: [
        ExternalAPIKeyComponent,
        NewPasswordComponent,
        ChangePasswordComponent
    ],
    exports: [
        ExternalAPIKeyComponent,
        NewPasswordComponent,
        ChangePasswordComponent
    ],
    providers: [AuthenticationService]
})
export class AccountModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();

        hybridAdapterUtility.downgradeNg2Component('externalApiKey', ExternalAPIKeyComponent);
        hybridAdapterUtility.downgradeNg2Component('externalApiKey', ExternalAPIKeyComponent);
        hybridAdapterUtility.downgradeNg2Provider('authenticationService', AuthenticationService);
    }
}
